export type KratixType = 'resource' | 'promise';
export type KratixAnnotationProp =
  | 'type'
  | 'promise-name'
  | 'group'
  | 'version'
  | 'kind'
  | 'name'
  | 'namespace'
  | 'backstage-promise-template';
export const kratixNamespace = 'kratix.io' as const;
export type KratixAnnotation =
  `${typeof kratixNamespace}/${KratixAnnotationProp}`;

export type WithKratixAnnotations = {
  [K in KratixAnnotation]: string;
};
